module.exports = __webpack_public_path__ + "img/icon-stim.0618a23f.svg";